const headers = new Headers({
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

export const clientHubTrack = (body: object) => {
  const env = window.location.href.includes('accessstorage.ca')
    ? 'production'
    : 'staging';
  const apiUrl =
    env === 'production'
      ? 'https://datavault-express.storagevaultcanada.com/clientHub/track'
      : 'https://datavault-express-stg.storagevaultcanada.com/clientHub/track';
  fetch(apiUrl, {
    headers,
    method: 'POST',
    body: JSON.stringify(body),
  }).catch((err) => {
    // eslint-disable-next-line no-console
    console.error('Tracking request failed:', err);
  });
};

export const clientHubContact = async (body: object) => {
  const env = window.location.href.includes('accessstorage.ca')
    ? 'production'
    : 'staging';
  const apiUrl =
    env === 'production'
      ? 'https://datavault-express.storagevaultcanada.com/clientHub/contact/new'
      : 'https://datavault-express-stg.storagevaultcanada.com/clientHub/contact/new';
  const response = await fetch(apiUrl, {
    headers,
    method: 'POST',
    body: JSON.stringify(body),
  });
  return {
    ok: response.ok,
    status: response.status,
    body: await response.json(),
  };
};

export const clientHubRefer = async (body: object) => {
  const env = window.location.href.includes('accessstorage.ca')
    ? 'production'
    : 'staging';
  const apiUrl =
    env === 'production'
      ? 'https://datavault-express.storagevaultcanada.com/clientHub/referral/new'
      : 'https://datavault-express-stg.storagevaultcanada.com/clientHub/referral/new';
  const response = await fetch(apiUrl, {
    headers,
    method: 'POST',
    body: JSON.stringify(body),
  }).catch((error) => {
    return {
      ok: false,
      status: 500,
      json: () => `Error: ${error}`,
    };
  });
  return {
    ok: response.ok,
    status: response.status,
    body: await response.json(),
  };
};
